import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FETCH_DASHBOARD_INIT_ACTION,
  FETCH_DASHBOARD_SUCCESS_ACTION,
  FETCH_DASHBOARD_FAIL_ACTION,
  FETCH_TRIP_DATA_INIT_ACTION,
  FETCH_TRIP_DATA_SUCCESS_ACTION,
  FETCH_TRIP_DATA_FAIL_ACTION,
} from "./action";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

const getCountApi = (role) => {
  switch (role) {
    case "shipper-enterprise":
      return "/shipper";
    case "runner":
      return "/runner";
    case "shipper-individual":
      return "/shipper";
    case "shprAccount":
      return "/shipper";
    case "shprSupport":
      return "/shipper";
    case "runnerTrip":
      return "/runner";
    case "runnerSupport":
      return "/runner";
    case "runnerAccount":
      return "/runner";
    case "warehouse":
      return "/warehouse";
    default:
      return "";
  }
};

function* fetchDashboardList() {
  const token = localStorage.getItem("token");
  let role = localStorage.getItem("UserRole");
  let countEndPoint = getCountApi(role);

  try {
    const res = yield fetch(`${appConfig.ip}/count${countEndPoint}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DASHBOARD_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DASHBOARD_FAIL_ACTION, error: err });
    } else {
    }
  }
}

const getactiveorderApi = (role) => {
  switch (role) {
    case "shipper-enterprise":
      return "loadData";
    case "shipper-individual":
      return "loadData";
    case "shprAccount":
      return "loadData";
    case "shprSupport":
      return "loadData";
    case "runner":
      return "tripPlan";
    case "runnerTrip":
      return "tripPlan";
    case "runnerSupport":
      return "tripPlan";
    case "runnerAccount":
      return "tripPlan";
    default:
      return "";
  }
};

function* tripDataList(val) {
  const token = localStorage.getItem("token");
  let pageno = !val.value
    ? 1
    : val.value.page === undefined
    ? 1
    : val.value.page;
  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;
  let role = localStorage.getItem("UserRole");
  let orderEndPoint = getactiveorderApi(role);

  let url = "";
  let recieverParam = "";

  let statusurl = "";
  let statusParam = "";

  if (
    user.role === "shipper-enterprise" ||
    "shipper-individual" ||
    user.role === "shprAccount" ||
    user.role === "shprSupport"
  ) {
    statusurl = `&status=${"planned,ontrip"}`;
  }
  if (
    user.role === "runner" ||
    user.role === "runnerTrip" ||
    user.role === "runnerSupport" ||
    user.role === "runnerAccount"
  ) {
    statusParam = `&status=${user.orgId}`;
    statusurl = `&status=${"created"}`;
  }

  if (user.role === "shipper-enterprise" || "shipper-individual") {
    url = `&orgId=${userorgId}`;
  }
  if (
    user.role === "runner" ||
    user.role === "runnerTrip" ||
    user.role === "runnerSupport" ||
    user.role === "runnerAccount"
  ) {
    recieverParam = `&orgId=${user.orgId}`;
    url = `&orgId=${user.orgId}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/${orderEndPoint}?limit=10&page=${pageno}${url}${statusurl}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_TRIP_DATA_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TRIP_DATA_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* dashboardActionWatcher() {
  yield takeEvery(FETCH_DASHBOARD_INIT_ACTION, fetchDashboardList);
  yield takeEvery(FETCH_TRIP_DATA_INIT_ACTION, tripDataList);
}
